// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-container {
  text-align: center;
  padding: 20px;
  background-color: #f9f9f9;
}

.projects-container h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.projects-grid {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding-right: 12.5%;
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
}

.projects-grid::-webkit-scrollbar {
  display: none;
}

.project-card {
  flex: 0 0 25%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: left;
}

.project-image {
  width: 100%;
  height: 170px;
  object-fit: cover;
  margin-bottom: 20px;
}

.project-info {
  padding: 10px;
}

.project-info h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.project-info p {
  font-size: 12px;
  color: #666666;
  line-height: 1.6;
}

.project-card:nth-child(1) {
  background-color: #dadada;
}

.project-card:nth-child(2) {
  background-color: #dfd3cb;
}

.project-card:nth-child(3) {
  background-color: #fff8ee;
}

.project-card:nth-child(4) {
  background-color: #ffeee1;
}
.project-card:nth-child(5) {
  background-color: #ffeee1;
}

.projects-grid .project-card:last-child {
  margin-right: -12.5%;
}

.projects-grid:hover {
  overflow-x: auto;
}

@media (max-width: 768px) {
  .projects-grid {
    flex-direction: column;
    overflow-x: hidden;
    padding: 10%;
  }

  .project-card {
    flex: 0 0 auto;
    width: 100%;

    margin-bottom: 20px;
  }

  .project-image {
    height: 200px;
  }

  .projects-grid .project-card:last-child {
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MajorProjects/MajorProjects.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;;IAEX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".projects-container {\n  text-align: center;\n  padding: 20px;\n  background-color: #f9f9f9;\n}\n\n.projects-container h2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.projects-grid {\n  display: flex;\n  gap: 20px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding-right: 12.5%;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  position: relative;\n}\n\n.projects-grid::-webkit-scrollbar {\n  display: none;\n}\n\n.project-card {\n  flex: 0 0 25%;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: left;\n}\n\n.project-image {\n  width: 100%;\n  height: 170px;\n  object-fit: cover;\n  margin-bottom: 20px;\n}\n\n.project-info {\n  padding: 10px;\n}\n\n.project-info h3 {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.project-info p {\n  font-size: 12px;\n  color: #666666;\n  line-height: 1.6;\n}\n\n.project-card:nth-child(1) {\n  background-color: #dadada;\n}\n\n.project-card:nth-child(2) {\n  background-color: #dfd3cb;\n}\n\n.project-card:nth-child(3) {\n  background-color: #fff8ee;\n}\n\n.project-card:nth-child(4) {\n  background-color: #ffeee1;\n}\n.project-card:nth-child(5) {\n  background-color: #ffeee1;\n}\n\n.projects-grid .project-card:last-child {\n  margin-right: -12.5%;\n}\n\n.projects-grid:hover {\n  overflow-x: auto;\n}\n\n@media (max-width: 768px) {\n  .projects-grid {\n    flex-direction: column;\n    overflow-x: hidden;\n    padding: 10%;\n  }\n\n  .project-card {\n    flex: 0 0 auto;\n    width: 100%;\n\n    margin-bottom: 20px;\n  }\n\n  .project-image {\n    height: 200px;\n  }\n\n  .projects-grid .project-card:last-child {\n    margin-right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
